import { Box, Stack, Typography } from '@mui/material';
import Grid2 from '@mui/material/Unstable_Grid2';
import FieldListV2 from '/@/components/field-list-v2';
import { useOwnUserNode } from '/@/hooks/nodes';
import { useIsValidatedConsultant, useIsValidatedRV } from '/@/hooks/session';
import { _ } from '/@/locale';
import FieldsByCropDashboardCard from '/@/views/dashboard/components/dashboard-cards/fields-by-crop-dashboard-card';
import FieldsDashboardCard from '/@/views/dashboard/components/dashboard-cards/fields-dashboard-card';
import NextVisitCard from '../../../next-visit-card';

const GrowerDashboardCurrentCampaign = ({
    growerNodeId,
    withCards,
    showNewFieldButton,
    fieldsTourAnchors = false,
}: {
    growerNodeId: number;
    withCards?: boolean;
    showNewFieldButton?: boolean;
    fieldsTourAnchors?: boolean;
}) => {
    const isConsultant = useIsValidatedConsultant();
    const isRV = useIsValidatedRV();
    const ownUserNodeQuery = useOwnUserNode();
    const showNextVisitCard = (isConsultant || isRV) && ownUserNodeQuery.data?.id !== growerNodeId;

    return (
        <>
            {withCards && (
                <Box id={fieldsTourAnchors ? 'widgets-l' : undefined}>
                    <Grid2
                        container
                        spacing={3}
                        columns={{
                            xs: 12,
                            lg: showNextVisitCard ? 12 : 8,
                        }}
                        mx={'-12px !important'}
                    >
                        <Grid2 xs={12} md={6} lg={4} height='auto'>
                            <FieldsDashboardCard
                                userNodeId={growerNodeId}
                                showNewFieldButton={showNewFieldButton}
                                showAssignFieldsButton={showNewFieldButton}
                                assignFieldsButtonId={fieldsTourAnchors ? 'btn-asignar-productor' : undefined}
                            />
                        </Grid2>
                        <Grid2 xs={12} md={6} lg={4} height='auto'>
                            <FieldsByCropDashboardCard userNodeId={growerNodeId} rows={2} />
                        </Grid2>
                        {showNextVisitCard && (
                            <Grid2 xs={12} lg={4} height='auto'>
                                <NextVisitCard growerNodeId={growerNodeId} />
                            </Grid2>
                        )}
                    </Grid2>
                </Box>
            )}
            <Stack direction='column' spacing={2}>
                <Stack direction='column' spacing={1}>
                    <Typography color='primary' variant='h5'>
                        {_('Lotes')}
                    </Typography>
                    <Typography color='primary.mui.inactive' variant='subtitle2'>
                        {_('Buscá un lote por nombre y generá una recomendación rápida y precisa')}
                    </Typography>
                </Stack>
                <Stack
                    sx={{
                        background: 'white',
                        py: 3,
                        px: 2,
                    }}
                >
                    <FieldListV2
                        userNodeId={growerNodeId}
                        emptyMessage={_('Este productor aún no tiene lotes agregados')}
                    />
                </Stack>
            </Stack>
        </>
    );
};

export default GrowerDashboardCurrentCampaign;
